import { render, staticRenderFns } from "./StockReturn.vue?vue&type=template&id=027f87d4"
import script from "./StockReturn.vue?vue&type=script&lang=js"
export * from "./StockReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports